import {Button, TextField} from '@material-ui/core';
import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Alert from '@material-ui/lab/Alert';
import Loading from 'Shared/components/Loading';
import { requestPasswordReset, validAns } from 'Users/ducks/passwordRecovery';

const PasswordRecoverySecurityQues = () => {
  const validAnsNumber = useSelector((state: ReducerState) => state.user.passwordRecovery.validAns);
  const [clicked, setClicked] = useState(false);
  const securityQue = useSelector((state: ReducerState) => state.user.passwordRecovery.questionsForPasswordRecovery);
  const username = useSelector((state: ReducerState) => state.user.passwordRecovery.username);
  const dispatch = useDispatch();
  const [ansArr, updateAnsArr] = useState([]);
  const handlechange = (index: number, val: any) => {
    let newArr: any = [...ansArr]
    newArr[index] = val
    updateAnsArr(newArr)
  }
  const submit = () => {
    ansArr.map((val, index)=> {
      securityQue["Data"].questionList[index].response=val})

    var transformed: any = {};

    transformed.securityQuestions = securityQue["Data"].questionList;
    dispatch(requestPasswordReset(transformed, username));
    setClicked(true);
    dispatch(validAns(3));

  }
  return (
    <div className="password-recovery">
        <div className="password-recovery__form">
        {validAnsNumber === 3 && clicked ? (
          <Loading />
        ) : (
          <React.Fragment>
            <h1>Security Questions</h1>
            {securityQue["Data"].questionList.map((que:any, index: number) =>(
                <TextField
                    className="username-recovery__email-input"
                    variant="outlined"
                    id={que.id}
                    key={index}
                    autoComplete="off"
                    label={que.question}
                    fullWidth
                    value={ansArr[que.id]}
                    onChange={(e) => handlechange(index, e.target.value)}
                />
            ))}
            
            {(validAnsNumber<3 && clicked) && <div><Alert severity="error">Incorrect Answers. Attempts remaining: <b>{validAnsNumber}</b></Alert><br/></div>}

            <Button
                className="username-recovery__return-to-login-button"
                fullWidth
                onClick={()=>submit()}
                variant="contained"
                color="primary"
            >
                Submit
            </Button>
          </React.Fragment> )}
        </div>
    </div>
  );
};

export default PasswordRecoverySecurityQues;

